import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '../../app/api/apiSlice'

const capabilitiesDomainTypesAdapter = createEntityAdapter({})

const initialState = capabilitiesDomainTypesAdapter.getInitialState()

export const capabilitiesDomainTypesApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCapabilitiesDomainTypes: builder.query({
            query: () => ({
                url: '/capabilitiesDomainTypes/getCapabilitiesDomainTypes',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedCapabilitiesDomainTypes = responseData.map(capabilitiesDomainType => {
                    capabilitiesDomainType.id = capabilitiesDomainType._id
                    return capabilitiesDomainType
                })
                return capabilitiesDomainTypesAdapter.setAll(initialState, loadedCapabilitiesDomainTypes)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'CapabilitiesDomainType', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'CapabilitiesDomainType', id}))
                    ]
                } else {
                    return [ { type: 'CapabilitiesDomainType', id: 'LIST'}]
                }
            },
        }),
        createNewCapabilitiesDomainType: builder.mutation({
            query: initialCapabilitiesDomainType => ({
                url: '/capabilitiesDomainTypes/createNewCapabilitiesDomainType',
                method: 'POST',
                body: {...initialCapabilitiesDomainType,}
            }),
            invalidatesTags: [
                { type: 'CapabilitiesDomainType', id: "LIST" }
            ] 
        }),
        updateCapabilitiesDomainType: builder.mutation({
            query: initialCapabilitiesDomainType => ({
                url: '/capabilitiesDomainTypes/updateCapabilitiesDomainType',
                method: 'PATCH',
                body: {...initialCapabilitiesDomainType,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'CapabilitiesDomainType', id: arg.id },
                { type: 'CapabilitiesDomainType', id: 'LIST' }
            ],
        }),
        deleteCapabilitiesDomainType: builder.mutation({
            query: ({id}) => ({
                url: '/capabilitiesDomainTypes/deleteCapabilitiesDomainType',
                method: 'DELETE',
                body: {id}
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'CapabilitiesDomainType', id: arg.id}
            ]
        }),
    }),
})

export const {
    useGetCapabilitiesDomainTypesQuery,
    useCreateNewCapabilitiesDomainTypeMutation,
    useUpdateCapabilitiesDomainTypeMutation,
    useDeleteCapabilitiesDomainTypeMutation,
} = capabilitiesDomainTypesApiSlice

// returns the query result object
export const selectCapabilitiesDomainTypeResult = capabilitiesDomainTypesApiSlice.endpoints.getCapabilitiesDomainTypes.select()

// create memoized selector
const selectCapabilitiesDomainTypesData = createSelector(
    selectCapabilitiesDomainTypeResult,
    capabilitiesDomainTypeResult => capabilitiesDomainTypeResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllCapabilitiesDomainTypes,
    selectById: selectCapabilitiesDomainTypeById,
    selectIds: selectCapabilitiesDomainTypeIds,
} = capabilitiesDomainTypesAdapter.getSelectors(state => selectCapabilitiesDomainTypesData(state) ?? initialState)